interface NegativeResult {
  success: false;
  hasPin: boolean;
}

interface PositiveResultWithPin {
  success: true;
  hasPin: true;
  pin: string;
}

interface PositiveResultWithoutPin {
  success: true;
  hasPin: false;
}

export type PinRequestResult = NegativeResult | PositiveResultWithPin | PositiveResultWithoutPin;

export interface PinRequestCallbacks {
  before?: () => Promise<unknown> | void;
  after?: () => Promise<unknown> | void;
}

export interface CredentialSalts {
  passwordSalt: Uint8Array<ArrayBuffer>;
  pinSalt: Uint8Array<ArrayBuffer> | null;
}

export type CredentialErrorReason = 'PIN' | 'USER_SECRET';

export class CredentialError extends Error {
  constructor(
    public reason: CredentialErrorReason,
    message?: string,
  ) {
    super(message);
  }
}
